import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Appointment } from '../../../../shared/models/appointment.model';
import swal from 'sweetalert2';


@Component({
  selector: 'app-payment-appointment',
  templateUrl: './payment-appointment.component.html',
  styleUrls: ['./payment-appointment.component.css']
})
export class PaymentAppointmentComponent implements OnInit {

  showSpinnerCitasMedicas = false;
  cita: Appointment = {};


  constructor(
    private _router: Router,
    private route: ActivatedRoute) { }


  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.cita.nota = params['nota']; 
      this.cita.especialidad = params['especialidad'];
      this.cita.centro = params['centro'];
      this.cita.name = params['especialista'];
      this.cita.pagoConsultaVencida = params['pagoConsultaVencida'];
      this.mostrarAyuda();
    });
  }


  public mostrarAyuda() {
  
    var message = 'Para proceder con el pago en la pasarela de <b>Aval Pay Center</b> debe ingresar el <b>ID</b> de la consulta ' + 
    '<b>' + this.cita.nota + '</b> como referencia.';

    swal({
      title: 'Información',
      html: '<p style="font-size:14px"> ' + message + '</p>',
      type: 'info',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    }).then((result) => {
      if (result) {
        
      }
    });
  }


  pagarCita() {
    this.irAPasarelaAvalPayCenter();
  }


  irAPasarelaAvalPayCenter() {
    window.open("https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00013392&origen=buscar", "_blank");
  }


  volver() {
    this._router.navigate(['/office/medical_appointment/consult']);
  }


  irHomeCitasMedicas() {
    this._router.navigate(['/office/medical_appointment/home']);
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/medical-appointment/payment-appointment/payment-appointment/payment-appointment.component.ts